export function setupFocusTrap(modalNode, options = {}) {
  if (!modalNode) return
  const { autoFocus = true } = options

  const focusableSelectors = [
    'a[href]',
    'button:not([disabled])',
    'textarea:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    '[tabindex]:not([tabindex="-1"])',
  ]
  const focusableEls = modalNode.querySelectorAll(focusableSelectors.join(','))
  const firstEl = focusableEls[0]
  const lastEl = focusableEls[focusableEls.length - 1]

  if (autoFocus && firstEl) firstEl.focus()

  function handleKeyDown(e) {
    if (e.key === 'Tab') {
      if (focusableEls.length === 0) return
      if (e.shiftKey) {
        // Shift+Tab
        if (document.activeElement === firstEl) {
          e.preventDefault()
          lastEl.focus()
        }
      } else {
        // Tab
        if (document.activeElement === lastEl) {
          e.preventDefault()
          firstEl.focus()
        }
      }
    }
  }

  modalNode.addEventListener('keydown', handleKeyDown)
  return () => {
    modalNode.removeEventListener('keydown', handleKeyDown)
  }
}
